<p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-3"></p-breadcrumb>

<div class="p-card dashboards-card">
  <div class="p-px-3 p-pt-3 p-pb-1">
    <h3 class="p-mt-0 p-mb-2">Dashboards</h3>
  </div>
  <div class="p-px-4 p-pb-3 dashboards-grid">
    <a
      *ngFor="let dashboard of visibleDashboards"
      class="dashboard-tile"
      [routerLink]="['/reports', 'dashboards', dashboard.slug]"
    >
      <i class="pi {{ dashboard.icon }}" style="font-size: 1.5rem" aria-hidden="true"></i>
      <span class="dashboard-tile-name">{{ dashboard.name }}</span>
    </a>
  </div>
</div>